import React, { useState, useEffect } from "react";
import FormularioDinamico from "../../../common/components/formularios/FormularioDinamico";
import { useApi } from "../../../hooks/useApi"; // Importamos tu hook de conexión

export default function GestionFormularios({ usuario, onBackToMenu }) {
  const [formularioActivo, setFormularioActivo] = useState(null);
  const [formularios, setFormularios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  const { request } = useApi();

  // Cargar la lista de formularios disponibles desde la BD
  useEffect(() => {
    const cargarFormularios = async () => {
      setLoading(true);
      // Asumimos que tienes una ruta base que devuelve todos los config_formularios
      const res = await request('/formularios-dinamicos');
      
      if (res && res.success && res.data) {
        setFormularios(res.data);
      } else {
        setError("No se pudieron cargar los formularios disponibles.");
      }
      setLoading(false);
    };

    cargarFormularios();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="w-full animate-fade-in-up">
      {/* HEADER DEL MÓDULO */}
      <div className="flex flex-col sm:flex-row justify-between items-center mb-8 gap-4 bg-white/40 glass-panel p-6 rounded-3xl border border-white/60 shadow-sm">
        <div>
          <h1 className="text-2xl font-black text-slate-900 flex items-center gap-3">
            <span className="text-3xl">📋</span> Gestión de Formularios
          </h1>
          <p className="text-sm text-slate-600 font-medium mt-1">
            Administración y diligenciamiento de formatos dinámicos
          </p>
        </div>
        <button 
          onClick={onBackToMenu}
          className="btn-interactive px-5 py-2.5 bg-slate-900 text-white rounded-full text-xs font-bold shadow-md hover:bg-slate-800 tracking-wide uppercase cursor-pointer"
        >
          Volver al Menú
        </button>
      </div>

      {/* ÁREA DE TRABAJO */}
      {!formularioActivo ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          
          {/* Estados de Carga y Error */}
          {loading ? (
            <div className="col-span-full py-16 flex flex-col items-center justify-center">
              <div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mb-3"></div>
              <p className="text-slate-700 font-bold text-sm uppercase tracking-widest">Cargando formatos...</p>
            </div>
          ) : error ? (
            <div className="col-span-full bento-card p-6 bg-red-50/80 border-red-200 text-red-700 text-center rounded-2xl">
              <p className="font-bold">⚠️ {error}</p>
            </div>
          ) : formularios.length === 0 ? (
            <div className="col-span-full bento-card p-10 text-center text-slate-500 font-bold rounded-2xl">
              No hay formularios configurados en la base de datos actualmente.
            </div>
          ) : (
            /* Renderizado Dinámico de Formularios */
            formularios.map((form) => (
              <div key={form.slug} className="bento-card p-6 flex flex-col justify-between h-full group hover:border-blue-300 transition-all cursor-pointer">
                <div>
                  <div className="w-12 h-12 rounded-xl bg-blue-100 text-blue-600 flex items-center justify-center text-2xl mb-4 icon-bounce">
                    {form.icono || "📄"}
                  </div>
                  <h3 className="font-extrabold text-slate-900 text-lg mb-2">{form.titulo}</h3>
                  <p className="text-xs text-slate-500 font-medium mb-4 line-clamp-2">
                    {form.descripcion}
                  </p>
                </div>
                <button 
                  onClick={() => setFormularioActivo(form.slug)}
                  className="w-full py-3 bg-blue-50 text-blue-700 rounded-xl text-xs font-black uppercase tracking-wider group-hover:bg-blue-600 group-hover:text-white transition-all btn-interactive cursor-pointer"
                >
                  Diligenciar
                </button>
              </div>
            ))
          )}
        </div>
      ) : (
        <div>
          <FormularioDinamico 
            slug={formularioActivo} 
            usuario={usuario} 
            onGuardadoExitoso={(res) => {
              alert("¡Formulario guardado con éxito! ID: " + res.respuesta_id);
              setFormularioActivo(null);
            }}
            onCancelar={() => setFormularioActivo(null)} 
          />
        </div>
      )}
    </div>
  );
}